export class GlobalConf {
    public static salleID: number[] = [1, 2, 3, 4];

}